import Gauge from './Gauge';
import MiniArea from './MiniArea';
import Pie from './Pie';
import TagCloud from './TagCloud';
import WaterWave from './WaterWave';

const Charts = {
  Pie,
  WaterWave,
  Gauge,
  MiniArea,
  TagCloud,
};

export { Charts as default, Pie, WaterWave, Gauge, TagCloud, MiniArea };
